// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1DK1J","productName":"Table_productName__1yB_a"};